"use client";

import Navbar from "./Navbar";
import SessionExpirationHandler from "./SessionExpirationHandler";
import { usePathname } from "next/navigation";

const HIDE_NAVBAR_ROUTES = [
  "/admin/sign-in",
  "/cashier/sign-in",
  "/create-account",
  "/sign-in",
  "/reset-password",
  "/admin/reset-password",
  "/cashier/reset-password",
];

export default function NavbarWrapper() {
  const pathname = usePathname();

  const shouldHideNavbar = HIDE_NAVBAR_ROUTES.some((route) =>
    pathname.startsWith(route)
  );

  return (
    <>
      <SessionExpirationHandler />
      {!shouldHideNavbar && <Navbar />}
    </>
  );
}
